














import {Vue, Component, Prop, Mixins} from 'vue-property-decorator';
import {MenuItem} from '.';
import scrollToMixin from '@/mixins/scrollToMixin';

@Component({
    mixins: [scrollToMixin],
})
export default class MobileNavigation extends scrollToMixin {
    @Prop() menuItems!: MenuItem[];
    @Prop() value!: MenuItem;

    scrollOffset = 50;

    offset = 50;

    showMenu = false;

    clickOutside() {
        this.showMenu = false;
    }

    clickMenuItem(item: MenuItem) {
        this.scrollTo(item.href);
        this.$emit('input', item);
        this.showMenu = false;
    }
}
